import * as React from 'react';
import { LinkProps } from 'react-router-dom';

import { ChevronRight } from 'react-feather';
import { isNil } from '../utils/isNil';
import { FeatherIcon } from './FeatherIcon';
import { InternalLink } from './InternalLink';
import { FeatherIconName } from './FeatherIconName';

interface Props {
  to: LinkProps['to'];
  children: string;
  description?: string;
  className?: string;
  icon?: FeatherIconName;
}

export const LinkListItem: React.FC<Props> = ({
  children,
  description,
  className = '',
  to,
  icon,
}) => {
  return (
    <InternalLink to={to} className={`flex justify-between py-4 ${className}`}>
      <div className="flex">
        {!isNil(icon) ? (
          <FeatherIcon icon={icon} className="mr-3 flex-shrink-0" />
        ) : null}
        <div>
          <h3>{children}</h3>
          {!isNil(description) ? (
            <p className="text-sm text-grey-600">{description}</p>
          ) : null}
        </div>
      </div>
      <ChevronRight className="self-center flex-shrink-0 ml-2 text-grey-600" />
    </InternalLink>
  );
};
